@if (incomeTaxEntity$ | async) {
  <form [formGroup]="fromGroup">
    <snelstart-ui-number-form-control [decimals]="0"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="terugontvangenPremieLijfrente"
                                      id="terugontvangenPremieLijfrente"
                                      label="Ontvangen premies lijfrente"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [decimals]="0"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="terugontvangenPremieAOV"
                                      id="terugontvangenPremieAOV"
                                      label="Ontvangen premies arb.ong.verz."
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </form>
}
